export class LanguageDomain {
  /**
   * ブラウザの言語設定を元に表示言語を取得する
   */
  static getDefaultLanguage(): string {
    return window.navigator.language.slice(0, 2) == 'ja' ? 'ja' : 'en';
  }

  /**
   * serLocaleを元に表示言語を取得する
   * @param userLocale ユーザーの言語情報
   */
  static getLanguage(userLocale: string): string {
    if (userLocale == 'ja' || userLocale == 'en') {
      return userLocale;
    }
    return this.getDefaultLanguage();
  }
}
